<template>
  <el-container>
    <el-header>
      <el-row class="bb">
        <el-col :span="6">
          <div class="grid-content">
            订单归属
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            销售导购
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            绑定导购
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content">
            订单归属规则
          </div>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="6">
          <div class="grid-content">
            员工
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bb">
            100%
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bb" />
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            销售导购为<span class="red">员工</span>，无绑定导购
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content" />
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            <span> {{ proportionProps.sales.value }}% </span>
          </div>
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            <span>{{ proportionProps.bind.value }}%</span>
          </div>
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            销售导购为<span class="red">员工</span>，绑定导购为<span class="red">员工</span>
          </div>
        </el-col>
      </el-row><el-row>
        <el-col :span="6">
          <div class="grid-content bb" />
        </el-col>
        <el-col :span="6">
          <div class="grid-content bb" />
        </el-col>
        <el-col
          :span="3"
        >
          <div class="grid-content bb">
            {{ proportionProps.bind_operate.value }}%
          </div>
        </el-col>
        <el-col
          :span="3"
          class="grid-content bb"
        >
          <div v-if="excludeOperateStore.length > 0">
            <el-tooltip
              class="item"
              effect="light"
              placement="top"
            >
              <div slot="content">
                <div
                  v-for="(item, index) in excludeOperateStore"
                  :key="index"
                >
                  <div>{{ item }}</div>
                </div>
              </div>
              <span class="tooltip">已设置排他</span>
            </el-tooltip>
          </div>
        </el-col>

        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            销售导购为<span class="red">编外</span>，绑定导购为<span class="red">员工</span>
          </div>
        </el-col>
      </el-row><el-row>
        <el-col :span="6">
          <div class="grid-content">
            编外
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bb">
            100%
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bb" />
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content bb">
            销售导购为<span class="red">编外</span>，无绑定导购
          </div>
        </el-col>
      </el-row>
      <el-row class="bb">
        <el-col :span="6">
          <div class="grid-content" />
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content">
            {{ proportionProps.operate_bind.value }}%
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content" />
        </el-col>
        <el-col
          :span="6"
        >
          <div class="grid-content">
            销售导购为<span class="red">编外</span>，绑定导购为<span class="red">员工</span>
          </div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'DetailForm',
  props: {
    proportionProps: {
      type: Object
    }
  },
  data () {
    return {}
  },
  computed: {
    excludeOperateStore () {
      return this.proportionProps.excludeOperateStore
    }
  }
}
</script>

<style lang="scss" scoped>
.bb {
  border-bottom: 1px solid #e9e9e9;
}
.w45 {
  width: 45%;
}
.w90 {
  width: 90%;
}
.mr10 {
  margin-right: 10px;
}
.red {
  color: red;
}
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}

.el-header {
  text-align: bottom;
  line-height: 60px;
}

.el-main {
  text-align: left;
}
.el-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-container {
  background-color: #fff;
}
.grid-content {
  min-height: 36px;
  padding: 0 5px;
}
.tooltip {
  color: #409eff;
  margin-left: 20px;
}
</style>
